module.exports = __webpack_public_path__ + "img/corkboard.6409e564.svg";